<template>
	<div class="container">
		<div class="wrapper">
			<Navigation />
			<h2>Maak kennis met ons team van specialisten</h2>
			<div class="team">
				<div v-for="member in employees" class="member" :key="member.id">
					<div class="image" v-bind:style="{backgroundImage: `url(${member.image})`}"></div>
					<div class="title">
						<h3>{{ member.name }}</h3>
						<p>{{ member.functie }}</p>
					</div>
					<div class="contact">
						<i class="fas fa-envelope"></i>
						<p>{{ member.email }}</p>
						<i class="fas fa-phone"></i>
						<p>{{ member.tel }}</p>
						<i v-if="member.linkedIn" class="fab fa-linkedin"></i>
						<a v-if="member.linkedIn" :href="member.linkedIn" target="_blank"><p>LinkedIn</p></a>
					</div>
				</div>
			</div>
		</div>
		<Footer />
	</div>
</template>

<script>
	import Navigation from '../components/Navigation'
	import Footer from '../components/Footer'

	export default {
		name: 'Team',
		components: {
			Navigation,
			Footer,
		},
		data: function() {
			return {
				employees: [
					{
						id: 0,
						name: 'Georges Koslowski',
						image: require('../assets/georges.png'),
						functie: 'Bedrijfsrevisor',
						email: 'g.koslowski@conscius-audit.eu',
						tel: '0495 23 14 18',
						//linkedIn: 'https://www.linkedin.com/in/georges-koslowski-a943995/'						
					},
					{
						id: 1,
						name: 'Bruno Dereycke',
						image: require('../assets/member.png'),
						functie: 'Bedrijfsrevisor',
						tel: '0494 89 38 88',
						email: 'b.dereycke@conscius-audit.eu'
					},
					{
						id: 2,
						name: 'Natalie Vuijk',
						image: require('../assets/member.png'),
						functie: 'Audit manager',
						tel: '03 777 75 78',
						email: 'n.vuijk@conscius-audit.eu'
					}
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '../sass/team.scss';
</style>
